<template>
  <v-app
    :style="{background: $vuetify.theme.themes[$vuetify.theme.dark?'dark':'light'].backgroundLayouts}"
  >
    <default-bar />

    <default-view class="px-md-4 px-lg-6 px-xl-8" />

    <default-footer />
  </v-app>
</template>

<script>
  export default {
    name: 'DefaultLayout',

    components: {
      DefaultBar: () =>
        import(
          /* webpackChunkName: "default-app-bar" */
          './AppBar'
        ),

      DefaultFooter: () =>
        import(
          /* webpackChunkName: "default-footer" */
          '@/layouts/default/Footer'
        ),

      DefaultView: () =>
        import(
          /* webpackChunkName: "default-view" */
          '@/layouts/default/View'
        ),
    },
  }
</script>
